import apiFetch from './client';

export function getAppleDeveloperToken() {
  return apiFetch('/api/music/apple-token');
}

export function setMusicIntegration(userId, enabled) {
  return apiFetch(`/api/music/users/${userId}/music-integration?enabled=${enabled}`, {
    method: 'PATCH',
  });
}
